import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "vuecmf-table demo", -1);
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("此处可以自定义上传组件或接入外部文件管理器组件，如"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/vuecmf/vue-vuecmf-fileexplorer",
  target: "_blank"
}, "vue-vuecmf-fileexplorer"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 若直接本地文件上传，去掉vuecmf-table组件中upload_action属性即可。 ")], -1);
const _hoisted_4 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_vuecmf_table = _resolveComponent("vuecmf-table");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_vuecmf_table, {
    size: "default",
    export_file_name: "管理员列表",
    height: "400px",
    selectable: _ctx.selectable,
    checkbox: true,
    token: _ctx.token,
    page: "page",
    limit: 20,
    operate_width: 158,
    expand: false,
    detail_btn_visible: _ctx.detailBtnVisible,
    add_btn_visible: true,
    edit_btn_visible: _ctx.editBtnVisible,
    del_btn_visible: _ctx.delBtnVisible,
    expand_action: true,
    form_dialog_width: "70%",
    server: "http://www.vuecmf.com/vuecmf/vuecmf/test",
    import_server: "http://www.vuecmf.com/vuecmf/vuecmf/test/saveAll",
    save_server: "http://www.vuecmf.com/vuecmf/vuecmf/test/save",
    upload_server: "http://www.vuecmf.com/vuecmf/vuecmf/test/upload",
    del_server: "http://www.vuecmf.com/vuecmf/vuecmf/test/delete",
    onBeforeLoadTable: _ctx.beforeLoadTable,
    onAfterLoadTable: _ctx.afterLoadTable,
    show_type: "table",
    upload_action: _ctx.uploadAction
  }, {
    headerAction: _withCtx(selectRows => [_createVNode(_component_el_button, {
      size: "default",
      type: "danger",
      onClick: _withModifiers($event => _ctx.mulDel(selectRows), ["prevent"])
    }, {
      default: _withCtx(() => [_createTextVNode("批量删除")]),
      _: 2
    }, 1032, ["onClick"])]),
    rowAction: _withCtx(({
      row,
      index,
      service
    }) => [_createVNode(_component_el_button, {
      size: "default",
      type: "info",
      onClick: _withModifiers($event => _ctx.lock(row, index, service), ["prevent"])
    }, {
      default: _withCtx(() => [_createTextVNode("禁用")]),
      _: 2
    }, 1032, ["onClick"])]),
    formatRow: _withCtx(({
      row,
      field
    }) => [field == 'username' ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createVNode(_component_el_input, {
      modelValue: row[field],
      "onUpdate:modelValue": $event => row[field] = $event,
      onChange: _ctx.changeUser,
      size: "default",
      clearable: ""
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])])) : _createCommentVNode("", true)]),
    rowExpand: _withCtx(({
      row,
      index
    }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.expand_data.table_list, (item, k) => {
      return _openBlock(), _createElementBlock("div", {
        key: k
      }, _toDisplayString(item.col01) + " " + _toDisplayString(item.col02) + " " + _toDisplayString(index), 1);
    }), 128))]),
    _: 1
  }, 8, ["selectable", "token", "detail_btn_visible", "edit_btn_visible", "del_btn_visible", "onBeforeLoadTable", "onAfterLoadTable", "upload_action"]), _createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.dialogVisible = $event),
    title: "上传文件",
    width: "50%"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.dialogVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.saveFile
    }, {
      default: _withCtx(() => [_createTextVNode("确定")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }, 8, ["modelValue"])], 64);
}